import ImportHelper from './import.helper'

const GeneralView = () => { return ImportHelper.importAll(require.context("../assets/images/GeneralView/", true, /\.webp/)); }
const Torre1 = () => { return ImportHelper.importAll(require.context("../assets/images/Torre1/", true, /\.webp/)); }
const Torre2 = () => { return ImportHelper.importAll(require.context("../assets/images/Torre2/", true, /\.webp/)); }
const Torre3 = () => { return ImportHelper.importAll(require.context("../assets/images/Torre3/", true, /\.webp/)); }
const Torre4 = () => { return ImportHelper.importAll(require.context("../assets/images/Torre4/", true, /\.webp/)); }
const FirtView = () => { return ImportHelper.importAll(require.context("../assets/images/18mts/", true, /\.jpg/)); }
const SecondView = () => { return ImportHelper.importAll(require.context("../assets/images/39mts/", true, /\.jpg/)); }
const ThirdView = () => { return ImportHelper.importAll(require.context("../assets/images/59mts/", true, /\.jpg/)); }

export const ContextLoader = {
    "General View": GeneralView,
    "Torre 1": Torre1,
    "Torre 2": Torre2,
    "Torre 3": Torre3,
    "Torre 4": Torre4,
    "18.50": FirtView,
    "39.50": SecondView,
    "59.50": ThirdView,
}
